import React from "react";
import { useRouter } from "next/router";
import ReactGA_UA from "react-ga";
import ReactGA_4 from "react-ga4";
import dynamic from "next/dynamic";
import CustomersPage from "@components/CustomersPage/CustomersPage";
import { Leaf } from "@components/Leaf/Leaf";
import styles from "@components/CustomersPage/CustomersPage.module.scss";
import LaufidLoader from "@components/LaufidLoader/LaufidLoader";

const Page = dynamic(() => import("@components/Layout/page"), {
    loading: () => <LaufidLoader />,
});

function laufidPage() {
    const router = useRouter();
    React.useEffect(() => {
        ReactGA_UA.pageview(router.asPath);
        ReactGA_4.send({ hitType: "pageview", page: router.asPath });
    }, [router.query.q]);
    return (
        <div style={{ overflowX: "hidden" }}>
            <Page fluid bodyClassName={styles.pageBody}>
                <div className={styles.bgContainer}>
                    <Leaf className={styles.leaf1} plain />
                    <Leaf className={styles.leaf2} plain />
                    <Leaf className={styles.leaf3} plain />
                    <div className={styles.topGradient} />
                    <CustomersPage />
                </div>
            </Page>
        </div>
    );
}

export default laufidPage;

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../../locales/${locale}.json`)).default,
        },
    };
}
